import {
    Button,
    Divider,
    InputBase,
    InputAdornment,
    IconButton,
    Checkbox,
    CircularProgress,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import { ErrorOutline, Visibility, VisibilityOff } from "@mui/icons-material";
  import { useNavigate, useNavigation, useParams } from "react-router-dom";
  import axios from "axios";
  import {jwtDecode} from 'jwt-decode';
  
  const AcceptInvite = () => {
    const navigate = useNavigate();
    const {token} = useParams()
    const [showPassword, setShowPassword] = useState(false);
    const [user, setUser] = useState(null);
    const[remember_me, setRememberMe] = useState(true)
    const [err_msg, setErrorMsg] = useState(null);
    const [loader, setLoader] = useState(true)

    function decodeToken(token) {
        try {
          const decoded = jwtDecode(token);
          return decoded;
        } catch (error) {
          console.error('Invalid token:', error);
          return null;
        }
      }

    useEffect(() => {
        const decodedData = decodeToken(token)
        console.log(decodedData)
        setUser({
            user_id : decodedData.user_id,
            organization_id : decodedData.organization_id,
            type : decodedData.type,
        })
    }, [])
    
  
    const acceptInvite = async () => {
      setErrorMsg(null);
      setLoader(true);
      let u = user
      console.log(u.type)
      try {
          let user_data = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "update-user",
            {...u, status:'active'}
          )

          console.log('user_data', u.user_id)
          localStorage.setItem('organization', JSON.stringify(user_data.data.updatedItem) )

           let relatedOrgs = await axios .post(
                             process.env.REACT_APP_BACKEND_URL + "add-related-org",
                             {
                               user_id : u.user_id,
                               organization_name: user_data.data.updatedItem.organization_name.S ,
                               organization_id : user_data.data.updatedItem.orgId.S
                             }
                           )


                           localStorage.setItem('user',JSON.stringify(relatedOrgs.data.user))
                           console.log(user_data)


          let user_data_2 = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "get-user-by-id",
            {userId: user.user_id}
          )

  
          localStorage.setItem('user', JSON.stringify(user_data_2.data.user) )
  
          navigate("/dashboard/");
  
        setLoader(false);
      } catch (error) {
        console.log(error)
        if (error.response && error.response.data) {
          console.error("Response data:", error.response.data);
          setErrorMsg(error.response.data.message)
        }
        setLoader(false)
      }
    };


    useEffect(()=> {
if(user){
  acceptInvite()
}
    },[user])
    return (
      <div>
        <div className="grid lg:grid-cols-4">
          <div className="col-span-1 lg:pt-[150px] pt-[80px] bg-white h-[100vh] px-8  lg:my-0">
            <div className="flex items-center justify-center">
              <img src="/icons/login_img.png" className="w-[50px]" />
            </div>
            <div className="text-center lg:text-[16px] mt-4  font-semibold ">
            Accept Invite
            </div>
  
            {err_msg && (
              <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
                <ErrorOutline sx={{ fontSize: "" }} /> {err_msg}
              </div>
            )}
  
  {loader&& (
                          <div className="flex justify-center mt-2">   <CircularProgress
                          size={"1.6rem"}
                          sx={{ color: "blue" }}
                        /></div>
                          ) }
  
           
  
         
  
           
  
          
  
          
  
          
          </div>
  
          <div className="col-span-3 lg:flex justify-center my-auto hidden ">
            <img
              src="/icons/illustration.png"
              className=" w-[580px] h-[500px] "
            />
          </div>
        </div>
      </div>
    );
  };
  
  export default AcceptInvite;
  